var map = {
	"./icon-ad.svg": "a6be",
	"./icon-add-bonus.svg": "5369",
	"./icon-add-custom-cashback.svg": "48c1",
	"./icon-add-custom.svg": "c752",
	"./icon-add-gray.svg": "9958",
	"./icon-add.svg": "dcd2",
	"./icon-adjustment.svg": "12a6",
	"./icon-advt-tax.svg": "cef1",
	"./icon-arrow-blue.svg": "7a50",
	"./icon-arrow-gray-down.svg": "31a4",
	"./icon-arrow-gray.svg": "5e37",
	"./icon-arrow-red.svg": "7265",
	"./icon-arrow.svg": "ec21",
	"./icon-asc.svg": "00b7",
	"./icon-attach.svg": "311d",
	"./icon-avito.svg": "719c",
	"./icon-ba.svg": "6e5a",
	"./icon-back.svg": "e7ee",
	"./icon-bell.svg": "7744",
	"./icon-calendar.svg": "35f4",
	"./icon-capitalist-usa.svg": "f84c",
	"./icon-capitalist.svg": "0f3e",
	"./icon-card.svg": "f183",
	"./icon-cashback-statistic-usa.svg": "0d85",
	"./icon-cashback-statistic.svg": "6137",
	"./icon-cashback.svg": "9e6c",
	"./icon-cashless-usa.svg": "5c07",
	"./icon-cashless.svg": "9e0a",
	"./icon-chat.svg": "7d02",
	"./icon-check.svg": "dc7b",
	"./icon-clicks.svg": "ce2c",
	"./icon-close-black.svg": "33e8",
	"./icon-close-gray.svg": "8e3d",
	"./icon-close.svg": "3324",
	"./icon-coins-usa.svg": "1e5d",
	"./icon-coins.svg": "358d",
	"./icon-commission-cashback.svg": "e262",
	"./icon-commission.svg": "d9ec",
	"./icon-conversions.svg": "c1ab",
	"./icon-copy-clip-grey.svg": "478a",
	"./icon-copy-clip.svg": "eeb0",
	"./icon-copy-id-usa.svg": "8270",
	"./icon-copy-id.svg": "c93b",
	"./icon-cost-usa.svg": "7a13",
	"./icon-cost.svg": "00ca",
	"./icon-cross-button-small.svg": "3cd8",
	"./icon-cross-button.svg": "02fb",
	"./icon-cross-straight.svg": "5be5",
	"./icon-cross.svg": "d72e",
	"./icon-ctr.svg": "e12a",
	"./icon-delete-2.svg": "8a22",
	"./icon-delete-3.svg": "5957",
	"./icon-delete-4.svg": "d228",
	"./icon-delete-5.svg": "2094",
	"./icon-delete.svg": "273b",
	"./icon-desc.svg": "6f24",
	"./icon-docx-document.svg": "60c0",
	"./icon-done.svg": "453f",
	"./icon-download-white.svg": "4e35",
	"./icon-download.svg": "ae39",
	"./icon-edit-medium.svg": "1cf4",
	"./icon-edit-red.svg": "78b0",
	"./icon-edit.svg": "d5ef",
	"./icon-eye-closed.svg": "74b2",
	"./icon-eye.svg": "7615",
	"./icon-facebook-graph.svg": "6534",
	"./icon-facebook-logo.svg": "8a14",
	"./icon-facebook-new.svg": "47bc",
	"./icon-facebook.svg": "c263",
	"./icon-fain.svg": "4e3d",
	"./icon-faq-minus.svg": "99a8",
	"./icon-faq-plus.svg": "5399",
	"./icon-fine.svg": "0780",
	"./icon-google.svg": "e281",
	"./icon-holding.svg": "3dd8",
	"./icon-ivi.svg": "b8e4",
	"./icon-jpg.svg": "9cb2",
	"./icon-kinopoisk.svg": "87aa",
	"./icon-kpi.svg": "0320",
	"./icon-limit-usa.svg": "0ea1",
	"./icon-limit.svg": "6aa8",
	"./icon-load.svg": "8017",
	"./icon-logo.svg": "1b9a",
	"./icon-map.svg": "56df",
	"./icon-message.svg": "1bc6",
	"./icon-meta.svg": "3a6f",
	"./icon-metrika-pro.svg": "2d76",
	"./icon-mts.svg": "4b8a",
	"./icon-mytarget-graph.svg": "248e",
	"./icon-mytarget-logo.svg": "3fd2",
	"./icon-mytarget-new.svg": "d1dd",
	"./icon-mytarget.svg": "60dd",
	"./icon-out.svg": "ed20",
	"./icon-ozon.svg": "c22f",
	"./icon-partner-usa.svg": "e38b",
	"./icon-partner.svg": "f6f0",
	"./icon-pay-card-usa.svg": "8e98",
	"./icon-pay-card.svg": "f2b5",
	"./icon-pdf-document.svg": "7b67",
	"./icon-percent.svg": "52af",
	"./icon-png.svg": "9b68",
	"./icon-red-star.svg": "2d75",
	"./icon-refund-to-bonus.svg": "3fd5",
	"./icon-refund.svg": "ee2e",
	"./icon-replenishment.svg": "93a8",
	"./icon-round-dollar.svg": "1dcf",
	"./icon-save-medium.svg": "4a60",
	"./icon-search.svg": "6819",
	"./icon-send.svg": "0a70",
	"./icon-settings.svg": "1f26",
	"./icon-slide-next.svg": "fb03",
	"./icon-slide-prev.svg": "9601",
	"./icon-small-cross.svg": "cce4",
	"./icon-soloway.svg": "a6a3",
	"./icon-stars-sprite.svg": "ed35",
	"./icon-success.svg": "0212",
	"./icon-telegram-graph.svg": "cb95",
	"./icon-telegram-white.svg": "6153",
	"./icon-telegram.svg": "3aba",
	"./icon-tiktok.svg": "a5e6",
	"./icon-transfer-from-acc-to-balance.svg": "a761",
	"./icon-transfer-from-acc-to-cashback-balance.svg": "8538",
	"./icon-transfer.svg": "5ff7",
	"./icon-unactive-user.svg": "169d",
	"./icon-upload.svg": "c17b",
	"./icon-user-usa.svg": "f128",
	"./icon-user.svg": "e7c2",
	"./icon-views.svg": "37d7",
	"./icon-vk-acc-dell.svg": "42a6",
	"./icon-vk-graph.svg": "39c1",
	"./icon-vk-logo.svg": "c081",
	"./icon-vk-market.svg": "3e92",
	"./icon-vk.svg": "18a5",
	"./icon-vkadblogger.svg": "20ca",
	"./icon-vkontacte.svg": "b437",
	"./icon-vkreklama.svg": "4ec8",
	"./icon-wallet-red.svg": "a063",
	"./icon-wallet.svg": "b8b8",
	"./icon-withdrawal.svg": "0ffa",
	"./icon-xlsx-document-2.svg": "6d56",
	"./icon-xlsx-document.svg": "8487",
	"./icon-yandex-business.svg": "7dc8",
	"./icon-yandex-graph.svg": "6e58",
	"./icon-yandex.svg": "e4fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edcb";